"use client";

import { c as _c } from "react/compiler-runtime";
import { displayDate, isBeforeToday } from "@repo/design-system/utils/date-helpers";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
import { ContactImage } from "../../contact/contact-eon";
export default function ContactEonGridsolutions(t0) {
  const $ = _c(18);
  const {
    job
  } = t0;
  const t = useLanguage();
  let t1;
  if ($[0] !== t.jobad_contactHL) {
    t1 = <div className="mb-8 flex w-full font-medium text-4xl lg:text-5xl"><h2 className="lg:w-96" data-source="lc">{t.jobad_contactHL}</h2></div>;
    $[0] = t.jobad_contactHL;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = job.data.recruiterData?.recruiter_text;
  let t3;
  if ($[2] !== t2) {
    t3 = <p data-source="job">{t2}</p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== job.data.applicationEnd || $[5] !== t) {
    t4 = job.data.applicationEnd && !isBeforeToday(job.data.applicationEnd) ? <p data-source="lc">{t.jobad_contact_applicationEnd}<span className="font-bold">{displayDate(job.data.applicationEnd.slice(0, 10), t)}</span></p> : <p data-source="lc">{t.jobad_details_applicationDeadline}</p>;
    $[4] = job.data.applicationEnd;
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="pb-6">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t5) {
    t6 = <div className="flex flex-col">{t1}{t5}</div>;
    $[10] = t1;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== job) {
    t7 = <div className="flex justify-end"><ContactImage job={job} /></div>;
    $[13] = job;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <section className="outer-container bg-primary py-container text-lg text-white print:hidden" id="contact"><div className="inner-container"><div className="grid gap-3 lg:grid-cols-2">{t6}{t7}</div></div></section>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}